module.exports = __webpack_public_path__ + "img/cu.ced5bf8d.svg";